"use strict";
var __rest =
  (this && this.__rest) ||
  function (e, t) {
    var n = {};
    for (a in e)
      Object.prototype.hasOwnProperty.call(e, a) &&
        t.indexOf(a) < 0 &&
        (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols)
      for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
        t.indexOf(a[r]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(e, a[r]) &&
          (n[a[r]] = e[a[r]]);
    return n;
  };
let bbb_startTime = performance.now();
const BBB_IS_DEV = !1;
if (window.BBB_HAS_RUN)
  console.log("Bloom: Product Feature Bullets has already run");
else if (window.bbb_filterObject) {
  window.BBB_HAS_RUN = !0;
  const f = [
      "https://better-product-description.web.app/fontawesome%2Fv2%2Fcss%2Ffontawesome.css",
      "https://better-product-description.web.app/fontawesome%2Fv2%2Fcss%2Flight.css",
      "https://better-product-description.web.app/fontawesome%2Fv2%2Fcss%2Fregular.css",
      "https://better-product-description.web.app/fontawesome%2Fv2%2Fcss%2Fsolid.css",
      "https://better-product-description.web.app/fontawesome%2Fv2%2Fcss%2Fbrands.css",
    ],
    g = document.createDocumentFragment();
  f.forEach((e) => {
    var t = document.createElement("link");
    (t.type = "text/css"),
      (t.rel = "stylesheet"),
      (t.href = e),
      g.appendChild(t);
  }),
    document.head.appendChild(g),
    (async () => {
      var e,
        t,
        n,
        r,
        a,
        o,
        s = await bbb_fetchData();
      s.loadLimitExceeded
        ? console.error("Load limit exceeded.")
        : (({
            HTML: s = {},
            CUSTOM_CSS: e = "",
            GLOBAL_CSS: t = "",
            setsPluginsClientData: n,
          } = s),
          ({ variants: r, currently_selected_variant: a } = o =
            bbb_furtherObject),
          (o = __rest(o, ["variants", "currently_selected_variant"])),
          await bbb_injectBullets(
            bbb_insertDefaultVariables(
              s,
              Object.assign(
                Object.assign(Object.assign({}, bbb_filterObject), o),
                r[a]
              )
            ),
            t,
            e
          ),
          bbb_addPlugins(document, n),
          bbb_addEventListeners(document),
          bbb_addVariantListener(
            s,
            Object.assign(Object.assign({}, bbb_filterObject), o),
            r
          ));
    })();
} else console.warn("Bloom: Product Feature Bullets filter object not found");
async function bbb_fetchData() {
  var e = BBB_IS_DEV
    ? "http://127.0.0.1:5001/better-product-description/us-central1/getHTMLStorefrontV2?"
    : "https://us-central1-better-product-description.cloudfunctions.net/getHTMLStorefrontV2?";
  const n = new URLSearchParams();
  return (
    Object.entries(bbb_filterObject).forEach(([e, t]) => {
      n.append(e, String(t));
    }),
    (await fetch(e + n.toString())).json()
  );
}
function bbb_injectCSS(e) {
  var t = document.createElement("style");
  (t.innerHTML = e),
    (document.head || document.getElementsByTagName("head")[0]).appendChild(t);
}
function bbb_sortById(e, t) {
  return parseInt(e) - parseInt(t);
}
function bbb_injectHTML(a) {
  ["all", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach((n) => {
    var t =
      document.getElementsByClassName("better-bullets-container-" + n) || [];
    for (let e = 0; e < t.length; e++) {
      const r = t[e];
      Object.keys(a)
        .sort(bbb_sortById)
        .forEach((e, t) => {
          ("all" !== n && n !== t) ||
            ((t = document.createElement("div")).classList.add("b_b_b_" + e),
            (t.innerHTML = a[e]),
            r.appendChild(t));
        });
    }
  }),
    bbb_logInjectionTime(performance.now() - bbb_startTime);
}
async function bbb_injectBullets(e, t, n) {
  bbb_injectHTML(e), t && bbb_injectCSS(t), n && bbb_injectCSS(n);
}
function bbb_addVariantListener(r, a, o) {
  function e(n) {
    return function (...e) {
      var e = n.apply(this, e),
        t = bbb_getQueryParamValue(window.location.search, "variant");
      return (
        null !== t &&
          ((a = Object.assign(Object.assign({}, a), o[t])),
          bbb_updateTextContent(bbb_insertDefaultVariables(r, a))),
        e
      );
    };
  }
  (history.pushState = e(history.pushState)),
    (history.replaceState = e(history.replaceState));
}
function bbb_getQueryParamValue(e, t) {
  return new URLSearchParams(e).get(t);
}
function bbb_insertDefaultVariables(e, n) {
  const t = Object.assign({}, e);
  var r;
  n.compare_at_price &&
    ((r = (
      (e = Number(n.compare_at_price.replace(",", "."))) -
      Number(n.price.replace(",", "."))
    ).toFixed(2)),
    (n.price_difference = r),
    (n.price_discount = ((Number(r) / e) * 100).toFixed(0)));
  const a = /\{\{(\w+?)\}\}/g;
  return (
    Object.keys(t).forEach((e) => {
      t[e] = t[e].replace(a, (e, t) => {
        return n[t] ? String(n[t]) : e;
      });
    }),
    t
  );
}
function bbb_updateTextContent(o) {
  Object.keys(o).forEach((t) => {
    var n = document.getElementsByClassName("b_b_b_" + t);
    for (let e = 0; e < n.length; e++) {
      var r = n[e].firstChild,
        a = new DOMParser(),
        a =
          null ==
          (a =
            null ==
            (a = null == a ? void 0 : a.parseFromString(o[t], "text/html"))
              ? void 0
              : a.body)
            ? void 0
            : a.firstChild;
      r && a && bbb_compareAndReplaceNodes(r, a);
    }
  });
}
function bbb_compareAndReplaceNodes(e, t) {
  if (3 === e.nodeType && 3 === t.nodeType && e.textContent !== t.textContent)
    e.textContent = t.textContent;
  else if (1 === e.nodeType && 1 === t.nodeType) {
    var n = Array.from(e.childNodes),
      r = Array.from(t.childNodes);
    for (let e = 0; e < Math.min(n.length, r.length); e++)
      bbb_compareAndReplaceNodes(n[e], r[e]);
  }
}
function bbb_logInjectionTime(e) {
  console.log(
    `%cBloom took ${e.toFixed(0)} milliseconds to inject the Bullets`,
    "color: green"
  );
}
function bbb_addEventListeners(e) {
  e = e instanceof Document ? e.body : e.current;
  if (e)
    for (
      var t = e.getElementsByClassName("b-b-b-dropdown-button"),
        n = e.getElementsByClassName("b-b-b-dropdown-icon"),
        r = e.getElementsByClassName("b-b-b-dropdown-content"),
        a = 0;
      a < t.length;
      a++
    ) {
      const o = n[a],
        s = r[a];
      t[a].addEventListener("click", function (e) {
        e.stopPropagation();
        e = s.scrollHeight;
        s.style.setProperty("--max-height", e + "px"),
          s.style.setProperty("--top-margin", "7px"),
          s.style.setProperty("--bottom-margin", "10px"),
          o.classList.toggle("b-b-b-rotate-caret-up"),
          s.classList.toggle("b-b-b-no-height"),
          s.classList.toggle("b-b-b-full-height");
      });
    }
}
function bbb_addPlugins(e, t) {
  if (t && Object.keys(t).length) {
    const a = e instanceof Document ? e : e.current;
    a &&
      Object.keys(t).forEach((n) => {
        const r = t[n];
        Object.keys(r).forEach((e) => {
          var t = a.getElementsByClassName(`b_b_b_plugin_${e}_` + n);
          switch (e) {
            case "countdown":
              bbb_setupCountdownTimer(r[e], t);
              break;
            case "deliveryDate":
              bbb_setupDeliveryDate(r[e], t);
          }
        });
      });
  }
}
function bbb_setupCountdownTimer(
  {
    countdownType: n = "targetDate",
    targetDate: r,
    targetTime: a,
    countdownFormat: e,
    countdownTemplate: t,
    hideLeadingZeros: o,
  },
  s
) {
  const b = "custom" === t ? e : t;
  Array.from(s).forEach((t) => {
    t.intervalId && (clearInterval(t.intervalId), delete t.intervalId);
    var e = () => {
      var e;
      "repeatsForever" === n
        ? bbb_updateRepeatingCountdown(a, b, [t], o)
        : (e = bbb_getActualTargetDate(r, a)) instanceof Date &&
          !isNaN(e) &&
          bbb_updateCountdown(e, b, [t], o);
    };
    e(), (t.intervalId = setInterval(e, 1e3));
  });
}
function bbb_getActualTargetDate(e, t) {
  var [e, n, r] = e.split("/").map(Number);
  return new Date(r, e - 1, n, ...t.split(":").map(Number));
}
function bbb_updateCountdown(e, n, t, r = !1) {
  var a = new Date();
  const o = e.getTime() - a.getTime();
  t.forEach((e) => {
    var t = e.closest(".b-b-b-bullet-row");
    o <= 0
      ? (t && (t.style.display = "none"), (e.innerHTML = ""))
      : (t && (t.style.display = ""),
        (t = bbb_formatCountdown(bbb_calculateTimeComponents(o, n), n, r)),
        (e.innerHTML = t));
  });
}
function bbb_updateRepeatingCountdown(e, t, n, r = !1) {
  var a = new Date(),
    [e, o] = e.split(":").map(Number),
    e = new Date(a.getFullYear(), a.getMonth(), a.getDate(), e, o),
    o = (e < a && e.setDate(e.getDate() + 1), e.getTime() - a.getTime());
  let s = bbb_formatCountdown(bbb_calculateTimeComponents(o, t), t, r);
  n.forEach((e) => {
    (e.closest(".b-b-b-bullet-row").style.display = ""), (e.innerHTML = s);
  });
}
function bbb_formatCountdown(e, t, n) {
  const r = {
    weeks: bbb_formatNumber(e.weeks, n),
    days: bbb_formatNumber(e.days, n),
    hours: bbb_formatNumber(e.hours, n),
    minutes: bbb_formatNumber(e.minutes, n),
    seconds: bbb_formatNumber(e.seconds, n),
  };
  return t.replace(/\{\{(weeks|days|hours|minutes|seconds)\}\}/g, (e) => {
    var t = e.replace(/[\{\}]/g, "");
    return t in r ? r[t] : e;
  });
}
function bbb_formatNumber(e, t) {
  return t ? e.toString() : e.toString().padStart(2, "0");
}
function bbb_calculateTimeComponents(e, t) {
  let n = 0,
    r = 0,
    a = 0,
    o = 0,
    s = Math.floor(e / 1e3);
  return (
    t.includes("{{weeks}}") &&
      ((n = Math.floor(s / 604800)), (s -= 7 * n * 24 * 60 * 60)),
    t.includes("{{days}}") &&
      ((r = Math.floor(s / 86400)), (s -= 24 * r * 60 * 60)),
    t.includes("{{hours}}") && ((a = Math.floor(s / 3600)), (s -= 60 * a * 60)),
    t.includes("{{minutes}}") && ((o = Math.floor(s / 60)), (s -= 60 * o)),
    { weeks: n, days: r, hours: a, minutes: o, seconds: s }
  );
}
function bbb_setupDeliveryDate(e, t) {
  const n = bbb_formatDateString(bbb_calculateDeliveryDate(e), e);
  Array.from(t).forEach((e) => {
    e.innerHTML = n;
  });
}
function bbb_calculateDeliveryDate(e) {
  var t = parseInt(e.orderProcessingTime),
    n = parseInt(e.shippingTime),
    r = new Date(),
    [a, o] = e.cutOffTime.split(":").map(Number),
    s = new Date(r);
  s.setHours(a, o, 0, 0);
  let b = t + n;
  for (r.getTime() < s.getTime() && b--, r.setDate(r.getDate() + 1); 0 < b; )
    bbb_isWorkingDay(r, e) && !bbb_isHoliday(r, e) && b--,
      r.setDate(r.getDate() + 1);
  return r.setDate(r.getDate() - 1), r;
}
function bbb_isWorkingDay(e, t) {
  e = e.getDay();
  return t.workingDays[
    [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][e]
  ];
}
function bbb_isHoliday(e, t) {
  var n = bbb_formatDate(e, "MM/DD"),
    e = bbb_formatDate(e, "MM/DD/YYYY");
  return (
    t.commonHolidays.includes(n) ||
    t.customHolidays.includes(n) ||
    t.commonHolidays.includes(e) ||
    t.customHolidays.includes(e)
  );
}
function bbb_formatDate(e, t) {
  var n = e.getDate(),
    r = e.getMonth() + 1,
    e = e.getFullYear(),
    n = n < 10 ? "0" + n : n.toString(),
    r = r < 10 ? "0" + r : r.toString();
  if ("MM/DD" === t) return r + "/" + n;
  if ("MM/DD/YYYY" === t) return r + `/${n}/` + e;
  throw new Error("Unsupported format: " + t);
}
function bbb_formatDateString(n, r) {
  var e =
    "custom" !== r.deliveryDateTemplate
      ? r.deliveryDateTemplate
      : r.deliveryDateFormat;
  const a = navigator.language || "en-US",
    o = (e) => {
      e = e.toString();
      return r.hideLeadingZeros || 1 < e.length ? e : "0" + e;
    };
  return e.replace(
    /\{\{(week_day|date|date_nth|month|month_num|year|year_short|days_left)\}\}/g,
    (e) => {
      switch (e) {
        case "{{week_day}}":
          return n.toLocaleString(a, { weekday: "long" });
        case "{{date}}":
          return o(n.getDate());
        case "{{date_nth}}":
          return bbb_getOrdinalSuffix(n.getDate().toString());
        case "{{month}}":
          return n.toLocaleString(a, { month: "long" });
        case "{{month_num}}":
          return o(n.getMonth() + 1);
        case "{{year}}":
          return n.getFullYear().toString();
        case "{{year_short}}":
          var t = n.getFullYear().toString().substr(-2);
          return r.hideLeadingZeros || 1 < t.length ? t : "0" + t;
        case "{{days_left}}":
          return bbb_calculateDaysLeft(n).toString();
        default:
          return e;
      }
    }
  );
}
function bbb_calculateDaysLeft(e) {
  var t = new Date(),
    e = e.getTime() - t.getTime();
  return Math.ceil(e / 864e5);
}
function bbb_getOrdinalSuffix(e) {
  var t = parseInt(e) % 10,
    n = parseInt(e) % 100;
  return 1 == t && 11 != n
    ? e + "st"
    : 2 == t && 12 != n
    ? e + "nd"
    : 3 == t && 13 != n
    ? e + "rd"
    : e + "th";
}